import * as commonRegex from './../commonRegex';
import { InputType, InputValidationErrorCode } from './InputType';
const phoneNumberValidation = (text, isRequired) => {
  const numbers = text.replace(/-|_/gi, '');
  if (numbers.length === 0) {
    if (!isRequired) {
      return null;
    }
    return InputValidationErrorCode.RequiredError;
  }
  if (isNaN(Number(numbers))) {
    return InputValidationErrorCode.NumericalError;
  }
  if (numbers.length !== 10) {
    return InputValidationErrorCode.LengthError;
  }
  if (!commonRegex.PhoneNumber.test(text)) {
    return InputValidationErrorCode.FormatError;
  }
  return null;
};
const mileageValidation = (text, isRequired) => {
  const numbers = text.replace(/,/gi, '');
  if (isNaN(Number(numbers))) {
    return InputValidationErrorCode.NumericalError;
  }
  if (numbers.length === 0 && isRequired) {
    return InputValidationErrorCode.RequiredError;
  }
  if (numbers.length > 6) {
    return InputValidationErrorCode.LengthError;
  }
  if (!commonRegex.Mileage.test(text)) {
    return InputValidationErrorCode.FormatError;
  }
  return null;
};
const passwordValidation = (text, isRequired) => {
  if (!text && isRequired) {
    return InputValidationErrorCode.RequiredError;
  }
  return null;
};
const vinNumberValidation = (text, isRequired) => {
  if (!text && isRequired) {
    return InputValidationErrorCode.RequiredError;
  }
  if (text.length > 17) {
    return InputValidationErrorCode.LengthError;
  }
  return null;
};
const currencyValidation = (text, isRequired) => {
  const numbers = text.replace(/,|\$/gi, '');
  if (isNaN(Number(numbers))) {
    return InputValidationErrorCode.NumericalError;
  }
  if (numbers.length === 0 && isRequired) {
    return InputValidationErrorCode.RequiredError;
  }
  if (!commonRegex.Currency.test(text)) {
    return InputValidationErrorCode.FormatError;
  }
  return null;
};
const emailValidation = (text, isRequired) => {
  if (!isRequired && !text) {
    return null;
  }
  if (!text && isRequired) {
    return InputValidationErrorCode.RequiredError;
  }
  if (text && text.length > 50) {
    return InputValidationErrorCode.LengthError;
  }
  if (!commonRegex.Email.test(text)) {
    return InputValidationErrorCode.FormatError;
  }
  return null;
};
const zipCodeValidation = (text, isRequired) => {
  if (isNaN(Number(text))) {
    return InputValidationErrorCode.NumericalError;
  }
  if (!text && isRequired) {
    return InputValidationErrorCode.RequiredError;
  }
  if (text.length !== 5) {
    return InputValidationErrorCode.LengthError;
  }
  return null;
};
const firstAndLastNameValidation = (text, isRequired) => {
  if (!isRequired && !text) {
    return null;
  }
  if (!text && isRequired) {
    return InputValidationErrorCode.RequiredError;
  }
  if (text && text.length > 50) {
    return InputValidationErrorCode.LengthError;
  }
  if (commonRegex.HasSpecialChar.test(text)) {
    return InputValidationErrorCode.FormatError;
  }
  if (commonRegex.HasNumber.test(text)) {
    return InputValidationErrorCode.FormatError;
  }
  return null;
};
const commentValidation = (text, isRequired) => {
  if (!isRequired && !text) {
    return null;
  }
  if (!text && isRequired) {
    return InputValidationErrorCode.RequiredError;
  }
  if (text && text.length > 1000) {
    return InputValidationErrorCode.LengthError;
  }
  return null;
};
const cityValidation = (text, isRequired) => {
  if (!isRequired && !text) {
    return null;
  }
  if (!text && isRequired) {
    return InputValidationErrorCode.RequiredError;
  }
  if (text && text.length > 50) {
    return InputValidationErrorCode.LengthError;
  }
  if (commonRegex.HasSpecialChar.test(text)) {
    return InputValidationErrorCode.FormatError;
  }
  return null;
};
const streetAddressValidation = (text, isRequired) => {
  if (!isRequired && !text) {
    return null;
  }
  if (!text && isRequired) {
    return InputValidationErrorCode.RequiredError;
  }
  if (text && text.length > 50) {
    return InputValidationErrorCode.LengthError;
  }
  if (!isNaN(Number(text))) {
    return InputValidationErrorCode.FormatError;
  } else {
    if (!commonRegex.HasNumber.test(text)) {
      return InputValidationErrorCode.FormatError;
    }
  }
  return null;
};
export const inputValidation = (inputType, text, isRequired) => {
  const validator = {
    [InputType.PhoneNumber]: phoneNumberValidation(text, isRequired),
    [InputType.Mileage]: mileageValidation(text, isRequired),
    [InputType.Password]: passwordValidation(text, isRequired),
    [InputType.VinNumber]: vinNumberValidation(text, isRequired),
    [InputType.Currency]: currencyValidation(text, isRequired),
    [InputType.Email]: emailValidation(text, isRequired),
    [InputType.ZipCode]: zipCodeValidation(text, isRequired),
    [InputType.FirstName]: firstAndLastNameValidation(text, isRequired),
    [InputType.LastName]: firstAndLastNameValidation(text, isRequired),
    [InputType.Comment]: commentValidation(text, isRequired),
    [InputType.City]: cityValidation(text, isRequired),
    [InputType.StreetAddress]: streetAddressValidation(text, isRequired)
  };
  return validator[inputType];
};
//# sourceMappingURL=index.js.map